export default [
  {
    path: '/auth/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: 'login' */ './views/Login.vue')
  },
  {
    path: '/auth/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ './views/Login.vue')
  },
  {
    path: '/auth/register',
    name: 'Register',
    component: () =>
      import(/* webpackChunkName: 'register' */ './views/Register.vue')
  },
  {
    path: '/auth/forgot-password',
    name: 'Forgot password',
    component: () =>
      import(
        /* webpackChunkName: 'forgot-password' */ './views/ForgotPassword.vue'
      )
  },
  {
    path: '/auth/reset-password/:token',
    name: 'Reset password',
    component: () =>
      import(
        /* webpackChunkName: 'reset-password' */ './views/resetPassword.vue'
      )
  },
  {
    path: '/auth/maintenance',
    name: 'Maintenance',
    component: () =>
        import(/* webpackChunkName: 'maintenance' */ './views/Maintenance.vue')
  },
]
